module.exports = "<div class=\"badge\" [ngClass]=\"getClasses()\" [ngStyle]=\"getStyles()\">\n  <div class=\"arrow\" [ngClass]=\"getArrowClasses()\" *ngIf=\"arrow\"></div>\n  <ng-content></ng-content>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/common-components/badge/badge.component.html
// module id = ./src/app/home/common-components/badge/badge.component.html
// module chunks = main